import type { AppEnvironment } from './types';

/**
 * Generic production fallback. Used by web deploys that do not match a
 * specific vertical (`ip4x`, `ip4x-root`, `hire24`). Behaves like the
 * default Angular `environment.prod.ts` — production flag set, hostnames
 * point at IP4x infrastructure but no fixed root tenant.
 */
export const env: AppEnvironment = {
  production: true,
  buildMode: 'prod',
  apiBaseUrl: 'https://ip4x-za.sudosky.com/v1',
  coreApiUrl: 'https://ip4x-core-api.sudosky.com/v1',
  appTemplateId: '',
  authMode: 'core',
  portalOwnerType: 'member',
  loadDomainConfig: true,
  defaultDomain: '',
  rootTenantId: '',
  portalBaseUrl: 'https://member.ip4x.systems',
  appName: 'Member Portal',
  version: '1.0.0',
  appShell: 'classic',
  welcomeContent: {
    eyebrow: 'Resident companion',
    title: 'Your community,\nin your pocket.',
    subtitle: 'Access and services in one place.',
  },
  communitySelectContent: {
    title: 'Choose your community',
    subtitle: 'Search for your community to continue.',
  },
};
